import { render, staticRenderFns } from "./cModalServices.vue?vue&type=template&id=65008ea8&scoped=true"
import script from "./cModalServices.vue?vue&type=script&lang=js"
export * from "./cModalServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65008ea8",
  null
  
)

export default component.exports